import { ClassNameOnlyProps } from 'module/types/common';
import { TooltipPlacement } from 'antd/lib/tooltip';
import { ReactNode, Component, useRef } from 'react';
import { ControlledPopoverAction } from './controlled-popover-action';

interface Props extends ClassNameOnlyProps {
  title: ReactNode;
  allowed: (target: HTMLElement) => boolean;
  onShow?: () => void;
  hideChevron?: boolean;
  placement?: TooltipPlacement | undefined;
  disabled?: boolean;
  children?: ReactNode;
  type?: string;
  loading?: boolean;
}

interface State {
  visible: boolean;
}

interface Hideable {
  hide: () => void;
}

export class PopoverAction extends Component<Props, State> implements Hideable {
  constructor(props: Props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  private setVisible = (visible: boolean) => {
    this.setState({ visible }, () => {
      if (!visible) {
        return;
      }
      const { onShow } = this.props;

      onShow?.();
    });
  };

  hide = () => this.setVisible(false);

  render() {
    const {
      title,
      allowed,
      className,
      hideChevron,
      children,
      placement,
      disabled,
      loading,
      type = '',
    } = this.props;
    const { visible } = this.state;
    const { setVisible } = this;

    return (
      <ControlledPopoverAction
        className={className}
        title={title}
        loading={loading}
        allowed={allowed}
        visible={visible}
        setVisible={setVisible}
        hideChevron={hideChevron}
        placement={placement}
        disabled={disabled}
        type={type}
      >
        {children}
      </ControlledPopoverAction>
    );
  }
}

export const usePopoverActionRef = () => useRef<PopoverAction>(null);
